import { render, staticRenderFns } from "./AccountDigitalAssets.vue?vue&type=template&id=23a1f07b&"
import script from "./AccountDigitalAssets.vue?vue&type=script&lang=js&"
export * from "./AccountDigitalAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports